import { GAME_ID } from '../constants';

// action types for game flow & progress
export const SET_SCREEN = `${GAME_ID}/SET_SCREEN`;
export const SET_ALYX_STATE = `${GAME_ID}/SET_ALYX_STATE`;
export const START_ROUND = `${GAME_ID}/START_ROUND`;
export const EXIT_ROUND = `${GAME_ID}/EXIT_ROUND`;
export const INCREMENT_STANDARD_ROUND = `${GAME_ID}/INCREMENT_STANDARD_ROUND`;
export const START_PRACTICE = `${GAME_ID}/START_PRACTICE`;
export const EXIT_PRACTICE = `${GAME_ID}/EXIT_PRACTICE`;
export const INCREMENT_PRACTICE_ROUND = `${GAME_ID}/INCREMENT_PRACTICE_ROUND`;
export const INCREMENT_TOTAL_CORRECT = `${GAME_ID}/INCREMENT_TOTAL_CORRECT`;
export const COMPLETE_LEVEL = `${GAME_ID}/COMPLETE_LEVEL`;
export const ASK_FOR_HELP = `${GAME_ID}/ASK_FOR_HELP`;
